<script setup>
defineProps(['date', 'eventDates', 'eventVenueTimezones'])
defineEmits(['selectDate'])

const { features } = useFeatures()
</script>

<template>
  <DSStacked
    group="header-nav-stacking-group"
    teleport-target="#sticky-container"
    position="static"
  >
    <div
      class="flex flex-col bg-white"
    >
      <div class="p-4 pb-0 shadow-md">
        <ScheduleViewControl
          :date="date"
          class="lt-sm:hidden"
          @select-date="date => $emit('selectDate', date)"
        />
        <ScheduleDateControl
          :date="date"
          @update:date="date => $emit('selectDate', date)"
        />
        <ScheduleViewDateControl
          :date="date"
          :event-dates="eventDates"
          @select-date="date => $emit('selectDate', date)"
        />
      </div>
      <div class="m-4 flex items-center justify-between">
        <ScheduleViewNewCalendarToggle
          v-if="features.customer_v2_calendar_allow_user_toggle"
        />
        <span class="text-end text-sm text-text-400">
          <TimeZoneInfo :timezones="eventVenueTimezones" />
        </span>
      </div>
    </div>
  </DSStacked>
</template>
